export interface SalesNotification {
  id: string
  name: string
  city: string
  minutesAgo: number
}

export const salesNotifications: SalesNotification[] = [
  { id: 'n1', name: 'Carlos M.', city: 'Bogotá, CO', minutesAgo: 2 },
  { id: 'n2', name: 'Valeria R.', city: 'Ciudad de México, MX', minutesAgo: 4 },
  { id: 'n3', name: 'Andrés P.', city: 'Buenos Aires, AR', minutesAgo: 7 },
  { id: 'n4', name: 'Daniela S.', city: 'Madrid, ES', minutesAgo: 9 },
  { id: 'n5', name: 'Josué L.', city: 'Miami, US', minutesAgo: 12 },
  { id: 'n6', name: 'Camila T.', city: 'Santiago, CL', minutesAgo: 15 },
  { id: 'n7', name: 'Ricardo V.', city: 'Lima, PE', minutesAgo: 18 },
  { id: 'n8', name: 'Mariana G.', city: 'Guadalajara, MX', minutesAgo: 23 }
]
